import en from './en.json';
import ru from './ru.json';

export const dictionaryList = { en, ru };

export const languageOptions = {
    en: 'English',
    ru: 'Русский',
};